import { Popover } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Popover)`
  margin-left: ${(p) => p.theme.spacing(1)};
`;
